import { createSelector } from 'reselect'

import { IOnboardingState } from '../models'

export const selectChildrenRequestsData = (state: { onboarding: IOnboardingState }) =>
  state.onboarding.childrenRequestsData

export const selectChildrenRequestsLoadingStatus = createSelector(
  [selectChildrenRequestsData],
  ({ status }) => status
)
